var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import TctWindowEventContext from '../../context/tct-window-context';
import WindowConfigContext from '../../context/window-config-context';
import { convertIdToCssSelectorId } from '../../helpers/utils';
import { HermesysColors } from './Colors';
export var ButtonItems = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: solid 1px ", ";\n  padding: 5px;\n  color: white;\n  cursor: pointer;\n  border-radius: 2px;\n  width: 45%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n  flex-direction: column;\n  height: 70px;\n"], ["\n  border: solid 1px ", ";\n  padding: 5px;\n  color: white;\n  cursor: pointer;\n  border-radius: 2px;\n  width: 45%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n  flex-direction: column;\n  height: 70px;\n"])), HermesysColors.main.dimWhite);
export var emptyArrayItems = function (listLength, size) {
    return listLength === 0
        ? size
        : listLength % size > 0
            ? size - (listLength % size)
            : 0;
};
export function CommunicationTCT(props) {
    var _a = props.list, list = _a === void 0 ? [] : _a;
    var _b = React.useState(0), page = _b[0], setPage = _b[1];
    var size = 6;
    var totalPages = Math.round(list.length / size);
    var emptyCardsLength = emptyArrayItems(list.length, size);
    var data = __spreadArrays(list, new Array(emptyCardsLength).fill({ name: '' }));
    console.log('===set page', setPage);
    var config = useContext(WindowConfigContext);
    var _c = useContext(TctWindowEventContext), _onSelectCommunicationUser = _c._onSelectCommunicationUser, _onButtonClick = _c._onButtonClick;
    var buttonClick = config.isBuilder
        ? _onButtonClick
        : _onSelectCommunicationUser;
    return (React.createElement(React.Fragment, null,
        data.slice(page * size, page * size + size).map(function (item, index) { return (React.createElement(ButtonItems, { key: "communication_" + index, id: "" + convertIdToCssSelectorId(item.name), onClick: function () { return buttonClick("" + convertIdToCssSelectorId(item.name)); } }, item.name)); }),
        page !== 0 ? (React.createElement(ButtonItems, { id: "button_prev", onClick: function () { return buttonClick('button_prev'); } }, "Prev")) : (React.createElement("div", { style: { width: '45%' } })),
        totalPages > 0 && page !== totalPages - 1 && (React.createElement(ButtonItems, { id: "button_next", onClick: function () { return buttonClick('button_next'); } }, "Next"))));
}
var templateObject_1;
//# sourceMappingURL=Communication.js.map